export const PRODUCT_ORDER_TYPE = {
  RECEIVED: 'received',
  INVOICED: 'invoiced',
  ORDERED: 'ordered',
  DRAFT: 'draft',
};

// Used to specify if the user opened the order form from the order module or the preparation module
export const ORDER_SOURCES = {
  ORDERS: 'orders',
  PREPARATIONS: 'preparations',
};

export const MAX_CREDIT_ORDER_PICTURE_PER_ORDER = 10;
